var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTplogoutred(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8L4.64286 12V9H13V7H4.64286V4L0 8Z",
    fill: "#F93333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79863 3.05398e-05C8.72121 -0.00288353 7.6539 0.202773 6.65854 0.605085C5.66318 1.0074 4.75955 1.59837 4 2.34377L5.28838 3.60051C6.49294 2.42553 8.09476 1.77761 9.79863 1.77761C11.5025 1.77761 13.1043 2.42553 14.3089 3.60051C15.5134 4.77549 16.1777 6.33798 16.1777 8.00002C16.1777 9.66205 15.5134 11.2245 14.3089 12.3995C13.1043 13.5745 11.5025 14.2224 9.79863 14.2224C8.09476 14.2224 6.49294 13.5745 5.28838 12.3995L4 13.6563C5.54806 15.1672 7.60729 16 9.79863 16C11.99 16 14.0492 15.1672 15.5973 13.6563C17.1462 12.1462 18 10.1376 18 8.00002C18 5.86248 17.1462 3.85382 15.5973 2.34377C14.8377 1.59837 13.9341 1.0074 12.9387 0.605085C11.9434 0.202773 10.8761 -0.00288353 9.79863 3.05398e-05Z",
    fill: "#F93333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTplogoutred);
export default __webpack_public_path__ + "static/media/tplogoutred.17b3caba0e7a7a9a23186555c4ec6602.svg";
export { ForwardRef as ReactComponent };